import FittingEvaluationList from '../../modules/FittingEvaluation/FittingEvaluationList/fittingEvaluationList'

export default function FittingEvaluationScreen() {
    
    return (
        <>
            <FittingEvaluationList/>
        </>
    );
}